import { ActionTypes } from "../constants/action-types";

export const setCoachMarkViewed = (coachMarkId: string) => {
    return {
        type: ActionTypes.SET_COACH_MARK_VIEWED,
        payload: coachMarkId,
    };
};

export const setCoachMarksBulk = (viewedMap: { [key: string]: boolean }) => {
    return {
        type: ActionTypes.SET_COACH_MARKS_BULK,
        payload: viewedMap,
    };
};

export const resetCoachMarks = () => {
    return {
        type: ActionTypes.RESET_COACH_MARKS,
        payload: null,
    };
};
